import React from "react";
import { FaHeart } from "react-icons/fa";
import FooterMobile from "./FooterMobile";

export default function Footer() {
  const SOCIAL_MEDIA = [
    {
      id: 1,
      svg: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_236_9)">
            <path
              d="M16 18.8C14.5 18.8 13.2 17.6 13.2 16C13.2 14.5 14.4 13.2 16 13.2C17.5 13.2 18.8 14.4 18.8 16C18.8 17.5 17.5 18.8 16 18.8Z"
              fill="#FFF"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M19.4 9.19995H12.6C11.8 9.29995 11.4 9.39995 11.1 9.49995C10.7 9.59995 10.4 9.79995 10.1 10.1C9.86256 10.3374 9.7504 10.5748 9.61484 10.8617C9.57911 10.9373 9.54165 11.0166 9.49995 11.1C9.48448 11.1464 9.46662 11.1952 9.44747 11.2475C9.34286 11.5333 9.19995 11.9238 9.19995 12.6V19.4C9.29995 20.2 9.39995 20.6 9.49995 20.9C9.59995 21.3 9.79995 21.6 10.1 21.9C10.3374 22.1374 10.5748 22.2495 10.8617 22.3851C10.9374 22.4209 11.0165 22.4583 11.1 22.5C11.1464 22.5155 11.1952 22.5333 11.2475 22.5525C11.5333 22.6571 11.9238 22.8 12.6 22.8H19.4C20.2 22.7 20.6 22.6 20.9 22.5C21.3 22.4 21.6 22.2 21.9 21.9C22.1374 21.6626 22.2495 21.4252 22.3851 21.1383C22.4209 21.0626 22.4583 20.9835 22.5 20.9C22.5155 20.8536 22.5333 20.8048 22.5525 20.7525C22.6571 20.4667 22.8 20.0762 22.8 19.4V12.6C22.7 11.8 22.6 11.4 22.5 11.1C22.4 10.7 22.2 10.4 21.9 10.1C21.6626 9.86256 21.4252 9.7504 21.1383 9.61483C21.0627 9.57913 20.9833 9.54162 20.9 9.49995C20.8536 9.48448 20.8048 9.46661 20.7525 9.44747C20.4667 9.34285 20.0762 9.19995 19.4 9.19995ZM16 11.7C13.6 11.7 11.7 13.6 11.7 16C11.7 18.4 13.6 20.3 16 20.3C18.4 20.3 20.3 18.4 20.3 16C20.3 13.6 18.4 11.7 16 11.7ZM21.4 11.6C21.4 12.1523 20.9523 12.6 20.4 12.6C19.8477 12.6 19.4 12.1523 19.4 11.6C19.4 11.0477 19.8477 10.6 20.4 10.6C20.9523 10.6 21.4 11.0477 21.4 11.6Z"
              fill="#FFF"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 5C0 2.23858 2.23858 0 5 0H27C29.7614 0 32 2.23858 32 5V27C32 29.7614 29.7614 32 27 32H5C2.23858 32 0 29.7614 0 27V5ZM12.6 7.7H19.4C20.3 7.8 20.9 7.9 21.4 8.1C22 8.4 22.4 8.6 22.9 9.1C23.4 9.6 23.7 10.1 23.9 10.6C24.1 11.1 24.3 11.7 24.3 12.6V19.4C24.2 20.3 24.1 20.9 23.9 21.4C23.6 22 23.4 22.4 22.9 22.9C22.4 23.4 21.9 23.7 21.4 23.9C20.9 24.1 20.3 24.3 19.4 24.3H12.6C11.7 24.2 11.1 24.1 10.6 23.9C10 23.6 9.6 23.4 9.1 22.9C8.6 22.4 8.3 21.9 8.1 21.4C7.9 20.9 7.7 20.3 7.7 19.4V12.6C7.8 11.7 7.9 11.1 8.1 10.6C8.4 10 8.6 9.6 9.1 9.1C9.6 8.6 10.1 8.3 10.6 8.1C11.1 7.9 11.7 7.7 12.6 7.7Z"
              fill="#FFF"
            />
          </g>
          <defs>
            <clipPath id="clip0_236_9">
              <rect width="32" height="32" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      link: "https://instagram.com/scarpin.ir?igshid=YmMyMTA2M2Y",
    },
    {
      id: 2,
      svg: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_236_7)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5 0H27C29.7614 0 32 2.23858 32 5V27C32 29.7614 29.7614 32 27 32H5C2.23858 32 0 29.7614 0 27V5C0 2.23858 2.23858 0 5 0ZM16.6919 12.0074C15.2589 12.6034 12.3949 13.8371 8.09992 15.7083C7.40248 15.9856 7.03714 16.257 7.00388 16.5223C6.94767 16.9706 7.50915 17.1472 8.27374 17.3876C8.37774 17.4203 8.4855 17.4542 8.59598 17.4901C9.34822 17.7346 10.3601 18.0207 10.8862 18.0321C11.3633 18.0424 11.8959 17.8457 12.4839 17.4419C16.4968 14.7331 18.5683 13.3639 18.6983 13.3344C18.7901 13.3136 18.9172 13.2874 19.0034 13.3639C19.0895 13.4405 19.0811 13.5855 19.0719 13.6244C19.0163 13.8615 16.8123 15.9106 15.6717 16.971C15.3161 17.3015 15.0639 17.536 15.0124 17.5896C14.8969 17.7096 14.7791 17.823 14.666 17.9321C13.9672 18.6058 13.4431 19.111 14.695 19.936C15.2967 20.3325 15.7781 20.6603 16.2584 20.9874C16.7829 21.3446 17.306 21.7009 17.9829 22.1446C18.1554 22.2576 18.3201 22.375 18.4805 22.4894C19.0909 22.9246 19.6393 23.3155 20.3168 23.2532C20.7105 23.217 21.1172 22.8468 21.3237 21.7427C21.8118 19.1335 22.7712 13.4801 22.9929 11.1505C23.0123 10.9464 22.9879 10.6851 22.9683 10.5705C22.9486 10.4558 22.9076 10.2924 22.7586 10.1715C22.582 10.0283 22.3095 9.99805 22.1877 10.0001C21.6335 10.01 20.7834 10.3056 16.6919 12.0074Z"
              fill="#FFF"
            />
          </g>
          <defs>
            <clipPath id="clip0_236_7">
              <rect width="32" height="32" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      link: "https://t.me/scarpinChannel",
    },
    {
      id: 3,
      svg: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M27.7544 0.326904H4.24456C2.08036 0.326904 0.325928 2.08134 0.325928 4.24554V27.7553C0.325928 29.9195 2.08036 31.674 4.24456 31.674H27.7544C29.9186 31.674 31.673 29.9195 31.673 27.7553V4.24554C31.673 2.08134 29.9186 0.326904 27.7544 0.326904Z"
            fill="#FFF"
            stroke="#373435"
            stroke-width="0.652938"
            stroke-miterlimit="2.61313"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M25.5644 14.1919C24.5482 14.8782 23.8347 15.5826 22.992 16.4797C21.8668 17.6786 20.7314 18.7867 20.1552 19.2439C18.92 20.2419 17.7756 20.8091 16.6221 21.0109C16.0176 21.1209 15.0205 21.0745 14.4352 20.9282C13.9124 20.7909 13.9498 20.7637 13.7479 21.3672C13.5834 21.8344 13.4825 22.337 13.4462 22.8315L13.4189 23.216L13.2726 23.1887C12.1191 22.9607 10.9747 21.9717 10.5357 20.8182C10.3894 20.4519 10.3066 20.0583 10.2885 19.6556L10.2794 19.3357L9.98673 19.0703C9.37315 18.5021 8.97049 17.825 8.85141 17.1115C8.65058 15.9762 9.17233 14.6955 10.3066 13.542C11.5055 12.3249 13.2807 11.3733 15.0114 10.9979C15.6341 10.8697 16.7412 10.8324 17.2901 10.9242C18.37 11.117 19.258 11.666 19.807 12.4804C19.9806 12.7458 19.9897 12.7821 19.9725 13.0112C19.9725 13.1848 19.908 13.3503 19.798 13.4784C19.359 14.1001 18.041 14.7591 16.6312 15.0709C14.1415 15.629 12.549 14.9428 12.8054 13.4048C12.8235 13.2494 12.8417 13.1121 12.8326 13.1121C12.7963 13.0748 12.549 13.2029 12.2836 13.3957C11.8265 13.7065 11.4228 14.3292 11.2855 14.9145C11.2492 15.0709 11.2401 15.299 11.2583 15.5372C11.2775 15.849 11.3047 15.9671 11.442 16.2325C11.5237 16.4071 11.6983 16.6634 11.8265 16.7916L12.0545 17.0297L11.9637 17.1478C11.6983 17.496 11.4783 17.8896 11.3229 18.3013C11.2129 18.6404 11.1574 18.9976 11.1574 19.3539C11.1574 19.583 11.1766 19.8019 11.222 20.0219C11.3138 20.4619 11.6155 21.0654 11.9173 21.4227C12.1464 21.6881 12.6772 22.1453 12.76 22.1453C12.7872 22.1453 12.8054 22.0998 12.8054 22.0453C12.8054 21.8253 12.9789 21.1209 13.1172 20.7819C13.5189 19.7848 14.3978 18.924 15.7895 18.1822C16.0277 18.0631 16.6957 17.7341 17.2811 17.4687C18.5718 16.8642 19.2762 16.4989 19.6698 16.2234C20.7869 15.4362 21.4732 14.2656 21.7023 12.7821C21.784 12.2422 21.784 11.235 21.7023 10.686C21.3541 8.37099 19.6153 6.79668 17.1257 6.54035C14.3524 6.24768 10.8102 8.38916 8.63242 11.6932C7.57984 13.2948 6.85626 15.08 6.55452 16.8551C6.44452 17.5515 6.3981 18.8321 6.47177 19.473C6.65544 21.0927 7.24984 22.3925 8.27517 23.4178C8.78783 23.9305 9.39132 24.3604 10.0503 24.6621C12.3018 25.7329 14.7914 25.7611 16.9793 24.7358C17.9219 24.2867 18.8554 23.5914 19.8524 22.5943C20.8142 21.6235 21.4732 20.8091 23.2584 18.3659C23.7882 17.6332 24.7682 16.2607 25.5553 15.8026L25.5644 14.1919Z"
            fill="#153038"
          />
        </svg>
      ),
      link: "https://eitaa.com/ScarpinChannel",
    },
  ];
  return (
    <div className="w-full  h-[272px] hidden min-[769px]:flex  items-center justify-center bg-color-primary-C rounded-b-[10px] ">
      <div className="w-full max-w-[1440px] h-full flex flex-col items-center justify-between  ">
        <div
          dir="rtl"
          className="w-full h-[218px] flex items-center justify-between pr-[52px]  "
        >
          <div className="w-[930px] h-full flex flex-col items-center justify-between pt-[15px] pb-[10px] ">
            <div className="w-full flex items-center justify-start">
              <span className="font-font_primary_A font-bold text-[20px] text-color-primary-A">
                درباره اسکارپین
              </span>
            </div>
            <div className="w-full flex items-center justify-start">
              <p
                dir="rtl"
                className="w-[703px] font-font_primary_A font-normal text-[12px] text-color-primary-A leading-[21.6px] text-justify"
              >
                اسکارپین از سال 1400 با هدف پایش سلامت وسائل‌نقلیه توسط جوانان
                خلاق و توانمند در شرکت «پرشیا ایده و صنعت» طراحی و ساخته شده
                است. اسکارپین یک سامانه پویا و هوشمند بوده که براساس الگوی مصرف
                کاربران خودرو و با ساده سازی فرآیند تعویض قطعات و اقلام مصرفی،
                به حفظ و نگهداری خودرو کمک می‌نماید.
              </p>
            </div>
            <div className="w-full flex items-center justify-start gap-x-[4px]">
              <img
                src="../assets/images/other/location.svg"
                className="w-[12px] h-[17.5px]"
              />
              <p className="font-font_primary_A font-normal text-[11px] text-color-primary-A">
                خیابان دماوند بالاتر از وحیدیه ساختمان بهران پلاک 846 طبقه سوم
                واحد سوم شرقی
              </p>
            </div>
            <div className="w-full flex items-center justify-start gap-x-[4px]">
              <img
                src="../assets/images/other/email.svg"
                className="w-[12px] h-[17.5px]"
              />
              <p className="font-font_primary_A font-normal text-[12px] text-color-primary-A">
                info@scarpin.ir
              </p>
            </div>
            <div className="w-full flex items-center justify-start gap-x-[4px]">
              <img
                src="../assets/images/other/tel.svg"
                className="w-[12px] h-[17.5px]"
              />
              <p className="font-font_primary_A font-normal text-[12px] text-color-primary-A">
                021-77569568
              </p>
            </div>
          </div>
          <div className="w-[1px] h-[85%] mr-[75px] ml-[40px] border-[1px] border-[#E7E7E74D] "></div>
          <div className="w-[650px] h-full flex flex-col items-center justify-between pt-[23px] pb-[10px]  ">
            <div className="w-full flex items-center justify-center gap-x-[8px]">
              <a
                referrerPolicy="origin"
                target="_blank"
                href="https://trustseal.enamad.ir/?id=445283&Code=ONVCWoVCCnOUOfHdiWd8OCxNrMQsKJkx"
              >
                <div className="">
                  <img
                    referrerPolicy="origin"
                    src="https://trustseal.enamad.ir/logo.aspx?id=445283&Code=ONVCWoVCCnOUOfHdiWd8OCxNrMQsKJkx"
                    alt=""
                    style={{ cursor: "pointer" }}
                    Code="ONVCWoVCCnOUOfHdiWd8OCxNrMQsKJkx"
                    className="w-[117px] h-[117px] border-[1px]  border-[#a8a8a9] rounded-[5px] bg-color-primary-A p-[8px]"
                  />
                </div>
              </a>

              <div className="">
                <a
                  href="https://logo.samandehi.ir/Verify.aspx?id=364504&p=xlaogvkaaodsdshwobpdaods"
                  referrerPolicy="origin"
                  target="_blank"
                >
                  <img
                    referrerpolicy="origin"
                    id="rgvjfukzwlaoapfuesgtwlao"
                    style={{ cursor: "pointer" }}
                    src="https://logo.samandehi.ir/logo.aspx?id=364504&p=qftiwlbqshwlujynlymashwl"
                    className="w-[117px] h-[117px] border-[1px]  border-[#a8a8a9] rounded-[5px] bg-color-primary-A p-[8px]"
                  />
                </a>
              </div>
              <a href="https://qr.mojavez.ir/trace/2990947" target="_blank">
                <img
                  src="../assets/images/other/kasbokar.png"
                  className="w-[117px] h-[117px] bg-color-primary-A rounded-[5px] p-[8px]"
                />
              </a>
            </div>
            <div
              dir="ltr"
              className="w-full flex items-center justify-center  gap-x-[10px]"
            >
              {SOCIAL_MEDIA.map((social) => (
                <a key={social.id} href={social.link} target="_blank">
                  {social.svg}
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="w-[95%] h-[1px]  bg-[#E7E7E74D]"></div>
        <div className="w-full h-[54px] flex items-start justify-center pt-[8px]">
          <p
            dir="rtl"
            className="w-full font-font_primary_A font-normal text-[12px] text-color-primary-A flex items-center justify-center leading-[21.6px] text-center"
          >
            <span>طراحی شده با </span>
            <span className="ml-[8px] mr-[8px] text-[16px]">
              <FaHeart color="FEC42B" />
            </span>
            <span>
              و تمام حقوق این وبسایت برای شرکت خدمات خودرویی چوگان است.
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}
